module.exports = __webpack_public_path__ + "img/logo-header-white.46058894.png";